import axiosInstance from "api/axiosInstance";
import SAlert from "components/Alert";
import { currencyAction } from "./currency-slice";
import { batch } from "react-redux";
import exportAxiosInstance from "api/exportAxiosInstance";
import FileSaver from "file-saver";

// Get Currencies
export const getCurrencies =
  (
    url,
    pageNumber = 10,
    according = { order: "desc", name: "id" },
    search = null
  ) =>
  (dispatch) => {
    dispatch(currencyAction.setLoading(true));
    url = url || "/v1/currencies";
    axiosInstance
      .get(url, {
        params: {
          pageNumber: pageNumber,
          according: according,
          search: search,
        },
      })
      .then((response) => {
        if (response) {
          batch(() => {
            dispatch(currencyAction.setError(null));
            dispatch(currencyAction.setData(response.data));
            dispatch(currencyAction.setLoading(false));
          });
        }
      })
      .catch((error) => {
        dispatch(currencyAction.setLoading(false));
        console.log(error);
      });
  };

// Delete Currency
export const deleteCurrency = (id) => (dispatch) => {
  dispatch(currencyAction.setLoading(true));
  axiosInstance
    .delete(`/v1/currencies/${id}`)
    .then((response) => {
      dispatch(getCurrencies());
      SAlert({ title: "Success", text: "Currency successfully deleted" });
      batch(() => {
        dispatch(currencyAction.setError(null));
        dispatch(currencyAction.setLoading(false));
      });
    })
    .catch((error) => {
      dispatch(currencyAction.setLoading(false));
      console.log(error);
    });
};

// Store Currency
export const storeCurrency = (data, navigate) => (dispatch) => {
  dispatch(currencyAction.setLoading(true));
  axiosInstance
    .post("/v1/currencies", data)
    .then((response) => {
      navigate("/currencies");
      SAlert({ title: "Success", text: "Currency successfully inserted" });
      dispatch(currencyAction.setError(null));
      dispatch(currencyAction.setLoading(false));
    })
    .catch((err) => {
      dispatch(currencyAction.setLoading(false));
      dispatch(currencyAction.setError(err?.response?.data?.errors));
    });
};

// Update Currency
export const updateCurrency = (id, data, navigate) => (dispatch) => {
  dispatch(currencyAction.setLoading(true));
  axiosInstance
    .put(`/v1/currencies/${id}`, data)
    .then((respnose) => {
      navigate("/currencies");
      SAlert({ title: "Success", text: "Currency successfully updated" });
      dispatch(currencyAction.setError(null));
      dispatch(currencyAction.setLoading(false));
    })
    .catch((error) => {
      dispatch(currencyAction.setLoading(false));
      dispatch(currencyAction.setError(error?.response?.data?.errors));
    });
};

// Get Currency By Id
export const getByIdCurrency = (id) => (dispatch) => {
  dispatch(currencyAction.setLoading(true));
  axiosInstance
    .get(`/v1/currencies/${id}`)
    .then((respnose) => {
      batch(() => {
        dispatch(currencyAction.setError(null));
        dispatch(currencyAction.setLoading(false));
        dispatch(currencyAction.setCurrency(respnose.data));
      });
    })
    .catch((error) => {
      dispatch(currencyAction.setLoading(false));
      console.log(error);
    });
};

// Export Currencies
export const exportCurrencies = (search) => (dispatch) => {
  dispatch(
    currencyAction.setExportStatus({
      loading: true,
      error: null,
    })
  );
  exportAxiosInstance
    .get("/v1/currency-export", {
      params: { search },
    })
    .then((response) => {
      if (response) {
        const dataBlob = new Blob([response?.data], {
          type: "application/pdf,",
        });
        FileSaver.saveAs(dataBlob, `Currencies-${Math.random().toString()}.xlsx`);
        dispatch(
          currencyAction.setExportStatus({
            loading: false,
            error: null,
          })
        );
      }
    })
    .catch((error) => {
      dispatch(
        currencyAction.setExportStatus({
          loading: false,
          error: error?.response?.errors,
        })
      );
      console.log(error);
    });
};
